import React from "react";
import { useParams } from "react-router-dom";
import { getLocale } from "../../../system/helpers/localstorageHelper";
import { useNewsContent } from "../apiHooks";
import LandingTemplate from "../../Layouts/LandingTemplate";
import { Spin } from "antd";
import { PostView } from "../components/PostView";

export function NewsContent() {
  const { slug } = useParams();
  const locale = getLocale();
  const { data, isLoading } = useNewsContent({
    language: locale,
    slug: slug,
  });

  return (
    <LandingTemplate>
      <section className="custom-section">
        <div className="container">
          <Spin spinning={isLoading}>
            {data && <PostView post={data.post} />}
          </Spin>
        </div>
      </section>
    </LandingTemplate>
  );
}
